import { SelectInput } from "@risalabs_frontend_org/oasis-ui-kit";

interface DocumentsListProps {
  documentsList: { value: string; label: string }[];
  label?: string;
  onChange?: (value: string) => void;
  className?: string;
}

const DocumentsList = (props: DocumentsListProps) => {
  const { documentsList, label, onChange, className } = props;
  return (
    <div className={`documents-list-container w-full ${className ?? ""}`}>
      <SelectInput
        options={documentsList}
        placeholder="Select a document from the list"
        onChange={(value) => {
          onChange?.(value);
        }}
        label={label ?? "Auth Letter"}
      />
    </div>
  );
};

export default DocumentsList;
